import { createStyles, withStyles } from '@material-ui/core';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { OcDataview } from '../../comps/OcDataview';
import { OcDataviewFiltering } from '../../comps/OcDataviewFiltering';
import { PleaseWait } from '../../comps/PleaseWait';
import { DataviewStore } from '../../stores/DataviewStore';
import { getOmnistore } from '../../stores/Omnistore';
import { OcScreen } from '../OcScreen';

const styles = createStyles({
});

const dataviewStore = DataviewStore.create({
	id: 'DbStatPage',
	orgColumns: [
		'name',
		'nTotal :int',
		'nAlive :int',
		'nNewDeleted :int',
		'nOldDeleted :int',
	],
	filtering: [{columns: ['name'], value: ''}],
	sorting: {column: 'name'},
});

@observer class _DbStatPage extends OcScreen<{classes: any}> {
	@computed get totalsStore() {
		return getOmnistore().entityManagerStore.byStoreId('DbStat');
	}

	submenu() {
		return [
			<OcDataviewFiltering key="filtering" state={dataviewStore} repo={this.totalsStore}/>
		];
	}

	componentDidMount() {
		this.totalsStore.fetch();
	}

	renderBody() {
		if (!this.totalsStore.etag) return <PleaseWait/>;
		return <OcDataview state={dataviewStore} repo={this.totalsStore}/>;
	}
}

export const DbStatPage = withStyles(styles)(_DbStatPage);
